function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { AelfIcon } from "../../icon/AelfIcon";
var AelfSVGComponent = function AelfSVGComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.147 4.038a7.386 7.386 0 1 1 10.445 10.445l-5.054 5.055-1.685-1.685 5.054-5.054a5.003 5.003 0 1 0-7.075-7.076l-8.424 8.424a7.386 7.386 0 0 0 10.445 10.446l6.625-6.625a.4.4 0 0 1 .566 0l1.119 1.12a.4.4 0 0 1 0 .565l-6.625 6.624c-3.815 3.815-10 3.815-13.815 0-3.815-3.815-3.815-10 0-13.815l8.424-8.424Zm-3.37 13.478 6.12-6.12a.4.4 0 0 0 0-.565l-1.12-1.119a.4.4 0 0 0-.565 0l-6.12 6.12a5.004 5.004 0 0 0 7.076 7.075l3.37-3.37-1.685-1.684-3.37 3.37a2.62 2.62 0 1 1-3.706-3.707Z"
  }));
};
var componentName = 'AttachOutlined';
export var AttachOutlined = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(AelfIcon, _extends({
    component: AelfSVGComponent,
    ref: ref
  }, props));
});
AttachOutlined.displayName = componentName;